import * as React from 'react';
import {BREAKPOINTS} from 'utilities/breakpoints';
import {Button, Section} from 'components/UIKit';
import {ImageOptions, PictureData, Picture} from 'components/UIKit/Picture';
import styles from './Hero.scss';

export interface HeroProps {
  heading: string;
  subhead?: string;
  cta: string;
  url: string;
  imageUrl?: string;
  pictureData?: PictureData;
}

const imageOptions: ImageOptions[] = [
  {
    breakpoint: BREAKPOINTS.mobile,
    fallback: true,
    options: {
      width: 414,
      height: 316,
    },
  },
  {
    breakpoint: BREAKPOINTS.tablet,
    options: {
      width: 1020,
      height: 449,
    },
  },
  {
    breakpoint: BREAKPOINTS.desktopUp,
    options: {
      width: 1600,
      height: 669,
    },
  },
];

export class Hero extends React.PureComponent<HeroProps> {
  render() {
    const {heading, subhead, cta, url, imageUrl, pictureData} = this.props;

    return (
      <div className={styles.Container}>
        <Picture
          imageClassName={styles.BackgroundImage}
          imageOptions={imageOptions}
          imageUrl={imageUrl}
          pictureData={pictureData}
          alt=""
        />
        <section className={styles.Hero}>
          <Section
            heading={heading}
            subhead={subhead}
            headingProps={{type: 'h1', inheritColor: true}}
            subheadProps={{inheritColor: true}}
            headerSpacing="large"
          >
            <Button label={cta} url={url} />
          </Section>
        </section>
      </div>
    );
  }
}
